import {
    CHILD_ADMIN_FAILED,
    CHILD_ADMIN_FETCHING,
    CHILD_ADMIN_SUCCESS,
} from "../../Constants.ts";

export interface ChildAdminState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: ChildAdminState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): ChildAdminState => {
    switch (type) {
        case CHILD_ADMIN_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case CHILD_ADMIN_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case CHILD_ADMIN_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
